import React, { forwardRef } from "react";

import XClose from "@uui/XClose";

import { Collapse, IconButton, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import CoachingImage from "@app/analytics/assets/Coaching.png";
import ROUTES from "@app/common/routes";

import Link from "@rui/Link";
import { Column, Row } from "@rui/Stack";
import { Img } from "@rui/styles";

const Container = styled(Collapse)(({ theme }) => ({
  backgroundColor: "#FFF",
  paddingTop: theme.spacing(2),
}));

const Banner = styled(Row)(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.shades.orange[100],
  borderRadius: "8px",
  padding: theme.spacing(2),
  paddingRight: theme.spacing(3),
  position: "relative",
}));

interface CoachingEducationBannerProps {
  onDismiss: () => void;
  show: boolean;
}

const CoachingEducationBanner = forwardRef<
  HTMLDivElement,
  CoachingEducationBannerProps
>(({ onDismiss, show }, ref) => {
  return (
    <Column ref={ref}>
      <Container in={show} unmountOnExit>
        <Banner spacing={2} justifyContent="space-between">
          <Column spacing={1}>
            <Typography variant="h3" color="shades.neutral.800">
              Your Personal Meeting Coach
            </Typography>
            <Typography variant="bodySecondaryReg" color="shades.neutral.700">
              Read coaching provides you with personalized feedback on your
              clarity, inclusion, and impact when you speak. This is only
              visible to you. View your progress over time in the Dashboard{" "}
              <Link
                href={ROUTES.COACHING_DEFAULT_SECTION}
                underline
                color="inherit"
              >
                Coaching tab
              </Link>
              .
            </Typography>
          </Column>
          <Img
            src={CoachingImage}
            sx={{ height: "100%", maxHeight: "100px" }}
          />
          <IconButton
            size="small"
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={onDismiss}
          >
            <XClose sx={{ fontSize: "20px", color: "shades.neutral.400" }} />
          </IconButton>
        </Banner>
      </Container>
    </Column>
  );
});

CoachingEducationBanner.displayName = "CoachingEducationBanner";

export default CoachingEducationBanner;
